import DecileCircles from "./DecileCircles";

const QUESTION_LABELS = {
  "Hvad synes dine lærere om dine fremskridt i skolen?": "svarer, at fremskridtene er under middel eller middel",
  "Hvis jeg bliver forstyrret i undervisningen, kan jeg hurtigt koncentrere mig igen.": "svarer sjældent eller aldrig",
  "Hvor tit kan du finde en løsning på problemer, bare du prøver hårdt nok?": "svarer sjældent eller aldrig",
  "Hvor tit kan du klare det, du sætter dig for?": "svarer sjældent eller aldrig",
  "Jeg gør gode faglige fremskridt i skolen.": "er uenige eller helt uenige",
  "Jeg klarer mig godt fagligt i skolen.": "er uenige eller helt uenige",
  "Kan du koncentrere dig i timerne?": "svarer sjældent eller aldrig",
  "Lykkes det for dig at lære dét, du gerne vil, i skolen?": "svarer sjældent eller aldrig",
  "Er det let at høre, hvad de andre elever siger i timerne?": "svarer sjældent eller aldrig",
  "Er det let at høre, hvad læreren siger i timerne?": "svarer sjældent eller aldrig",
  "Hvis der er larm i klassen, kan lærerne hurtigt få skabt ro.": "svarer sjældent eller aldrig",
  "Møder dine lærere præcist til undervisningen?": "svarer sjældent eller aldrig",
  "Andre elever accepterer mig, som jeg er.": "er uenige eller helt uenige",
  "De fleste af eleverne i min klasse er venlige og hjælpsomme.": "er uenige eller helt uenige",
  "Er du bange for at blive til grin i skolen?": "svarer altid eller for det meste",
  "Er du blevet mobbet i dette skoleår?": "svarer tit eller meget tit",
  "Er du glad for din klasse?": "svarer sjældent eller aldrig",
  "Er du glad for din skole?": "svarer sjældent eller aldrig",
  "Føler du dig ensom?": "svarer tit eller meget tit",
  "Hvor ofte føler du dig tryg i skolen?": "svarer sjældent eller aldrig",
  "Jeg føler, at jeg hører til på min skole.": "er uenige eller helt uenige",
  "Jeg kan godt lide pauserne i skolen.": "er uenige eller helt uenige",
};

const NATIONAL_AVG = {
  "Social trivsel": 9.6,
  "Faglig trivsel": 12.25,
  "Ro og orden": 11.4,
};

const INDICATORS = ["Social trivsel", "Faglig trivsel", "Ro og orden"];

function formatNumber(n) {
  return new Intl.NumberFormat("da-DK", {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(n);
}

function OverallStats({ indicator, overall }) {
  const val = Number(String(overall).replace(",", "."));
  const natAvg = NATIONAL_AVG[indicator];
  const diff = val - natAvg;

  return (
    <div className="overall-stats">
      <div className="stat">
        <span className="stat-value">{formatNumber(val)}</span>
        <span className="stat-label">procent negative svar</span>
      </div>
      <div className="stat">
        <span className={`stat-value ${diff > 0 ? "negative" : diff < 0 ? "positive" : ""}`}>
          {diff > 0 ? "+" : ""}{formatNumber(diff)}
        </span>
        <span className="stat-label">
          procentpoint {diff > 0 ? "dårligere" : diff < 0 ? "bedre" : "som"} end landsgennemsnit
        </span>
      </div>
    </div>
  );
}

function QuestionRow({ question }) {
  const label = QUESTION_LABELS[question.question] || "";
  return (
    <div className="question-row">
      <div className="question-info">
        <div className="question-text">{question.question}</div>
        <div className="question-percent">
          {question.percent}% {label}
        </div>
      </div>
      <div className="question-rating">
        <DecileCircles decil={question.decil} />
        <div className="rating-text">{getRatingText(question.decil)}</div>
      </div>
    </div>
  );
}

function getRatingText(decil) {
  if (decil < 5) return `Bedre end ${(10 - decil) * 10}%`;
  if (decil === 5) return "Tæt på middel (50%)";
  if (decil === 6) return "Lidt dårligere end middel";
  return `Dårligere end ${(decil - 1) * 10}%`;
}

export default function SchoolDetail({ school, data, loading, onClose }) {
  if (loading) {
    return (
      <div className="school-detail">
        <button className="close-btn" onClick={onClose}>&#10005;</button>
        <h2>{school.navn}</h2>
        <p className="kommune-label">{school.kommune}</p>
        <p className="loading">Henter data...</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="school-detail">
        <button className="close-btn" onClick={onClose}>&#10005;</button>
        <h2>{school.navn}</h2>
        <p className="kommune-label">{school.kommune}</p>
        <p>Kunne ikke hente data for denne skole.</p>
      </div>
    );
  }

  return (
    <div className="school-detail">
      <button className="close-btn" onClick={onClose}>&#10005;</button>
      <h2>
        {data.skole}, {data.kommune}
      </h2>
      <p className="besvarelser">{data.besvarelser} elever har besvaret</p>

      {INDICATORS.map((indicator) => {
        const indData = data.data[indicator];
        if (!indData) return null;
        return (
          <details key={indicator} open={indicator === "Social trivsel"}>
            <summary className="indicator-header">
              <h3>{indicator}</h3>
              <svg className="arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M18 9L12 15L6 9" stroke="currentColor" strokeWidth="2" />
              </svg>
            </summary>
            <div className="indicator-content">
              <OverallStats indicator={indicator} overall={indData.overall} />
              <div className="questions-header">
                <span>Spørgsmål og andel negative svar</span>
                <span>Trivsel ift. skoler i hele landet</span>
              </div>
              {indData.questions.map((q, i) => (
                <QuestionRow key={i} question={q} />
              ))}
            </div>
          </details>
        );
      })}
    </div>
  );
}
